export const primary = {
	main: '#263349',
}

export const secondary = {
	main: '#61A60E',
}

export const background = {
	app: {
		dark: '#000000',
		light: '#FFFFFF',
		baseWhite: '#FFFFFF',
	},
	element: {
		veryDark: '#1840BF',
		dark: '#527BFF',
		medium: '#90ABFF',
		light: '#CEDAFF',
		veryLight: '#EEF2FF',
	},
}

export const content = {
	veryDark: '#333335',
	dark: '#777',
	medium: '#D1D1D1',
	light: '#E6E6E6',
	veryLight: '#F8F8F8',
}

export const status = {
	success: {
		dark: '#309102',
		medium: '#3BB700',
		light: '#EBF8E5',
	},
	warning: {
		dark: '#EF8100',
		medium: '#FF9B04',
		light: '#FFF5E6',
	},
	error: {
		dark: '#B9431F',
		medium: '#FF2727',
		light: '#FF9090',
	},
}

export const hyperLink = {
	dark: '#1840BF',
	medium: '#527BFF',
	light: '#90ABFF',
}

export const other = {
	dark: '#4ADEDE',
	medium: '#797EF6',
	light: '#BCFEFE',
}

export const colors = {
	lightGrey: '#f2f2f2',
	text: {
		muted: '#52525B',
	},
	app: {
		default: '#D4D4D8',
	},
}

export const convertHexToRGBA = (hexCode, opacity = 1) => {
	if (!hexCode) return hexCode
	let hex = hexCode.replace('#', '')

	if (hex.length === 3) {
		hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`
	}

	const r = parseInt(hex.substring(0, 2), 16)
	const g = parseInt(hex.substring(2, 4), 16)
	const b = parseInt(hex.substring(4, 6), 16)

	/* Backward compatibility for whole number based opacity values. */
	if (opacity > 1 && opacity <= 100) {
		opacity = opacity / 100
	}

	return `rgba(${r},${g},${b},${opacity})`
}
